export default __webpack_public_path__ + "static/media/save-money.b41be55f.svg";